// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3JYJ2","info":"PatientInfo_info__3lAt3"};